import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { FunnelSchema, type Funnel } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function useFunnel(range: TimeRange, options: UseMetricOptions = {}) {
  return useQuery<Funnel>({
    queryKey: qk.metrics.funnel(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/funnel?${toSearchParams(range).toString()}`,
        { signal },
      );
      return FunnelSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
